var _excluded = ["children", "value", "index"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e];
    for (var r in t)
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
} return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e)
    return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++)
        o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
} return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r)
    return {}; var t = {}; for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n))
            continue;
        t[n] = r[n];
    } return t; }
import React, { useState, useContext, useEffect } from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import TeamAccess from './TeamAccess';
import RoleManagement from './RoleManagement';
import PolicyManagement from './PolicyManagement';
import Theme from './Theme';
import { isAuthorized } from '../utils/utilities';
import { SubmitSettings, ConfigContext } from '../components';
function CustomTabPanel(_ref) {
    var children = _ref.children, value = _ref.value, index = _ref.index, other = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ React.createElement("div", _extends({
        role: "tabpanel",
        hidden: value !== index,
        id: "settings-tabpanel-".concat(index),
        "aria-labelledby": "settings-tab-".concat(index)
    }, other), value === index && /*#__PURE__*/ React.createElement(Box, null, children));
}
var Settings = function Settings() {
    var _useContext = useContext(ConfigContext), configState = _useContext.configState;
    var _useState = useState((configState === null || configState === void 0 ? void 0 : configState.settings) || null), _useState2 = _slicedToArray(_useState, 2), settings = _useState2[0], setSettings = _useState2[1];
    // Sync settings when configState changes
    useEffect(function () {
        setSettings((configState === null || configState === void 0 ? void 0 : configState.settings) || null);
    }, [configState === null || configState === void 0 ? void 0 : configState.settings]);
    // Define available tabs with their permissions
    var availableTabs = [{
            label: 'Team access',
            component: /*#__PURE__*/ React.createElement(TeamAccess, null),
            permission: 'RBAC:ViewUser'
        }, {
            label: 'Roles',
            component: /*#__PURE__*/ React.createElement(RoleManagement, null),
            permission: 'RBAC:ViewRole'
        }, {
            label: 'Policies',
            component: /*#__PURE__*/ React.createElement(PolicyManagement, null),
            permission: 'RBAC:ViewPolicy'
        }, {
            label: 'Theme',
            component: /*#__PURE__*/ React.createElement(Theme, {
                settings: settings,
                setSettings: setSettings
            }),
            permission: 'RBAC:UpdateConfiguration'
        }];
    // Filter tabs based on permissions
    var visibleTabs = availableTabs.filter(function (tab) {
        return tab.permission === null || isAuthorized(tab.permission);
    });
    var _useState3 = useState(function () {
        // Start with the first available tab
        return visibleTabs.length > 0 ? 0 : -1;
    }), _useState4 = _slicedToArray(_useState3, 2), tabValue = _useState4[0], setTabValue = _useState4[1];
    var handleTabChange = function handleTabChange(event, newValue) {
        setTabValue(newValue);
    };
    // If no tabs are visible, show an access denied message
    if (visibleTabs.length === 0) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                bgcolor: '#ffffff',
                p: 3,
                borderRadius: 2,
                borderBottom: '1px solid #ebebeb',
                height: 99
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 2
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h4",
            color: "#212121"
        }, "Settings"))), /*#__PURE__*/ React.createElement(Box, {
            sx: {
                p: 3,
                bgcolor: '#f8f8f8'
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                textAlign: 'center',
                py: 8
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h6",
            color: "#666",
            gutterBottom: true
        }, "No Access to Settings"), /*#__PURE__*/ React.createElement(Typography, {
            variant: "body1",
            color: "#888"
        }, "You don't have permission to view any settings sections."))));
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            bgcolor: '#ffffff',
            p: 3,
            borderRadius: 2,
            borderBottom: '1px solid #ebebeb',
            height: 99
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        color: "#212121"
    }, "Settings"), /*#__PURE__*/ React.createElement(SubmitSettings, {
        settings: settings,
        setSettings: setSettings
    }))), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            p: 3,
            bgcolor: '#f8f8f8'
        }
    }, /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            borderBottom: '1px solid #ebebeb',
            px: 3,
            pt: 2
        }
    }, /*#__PURE__*/ React.createElement(Tabs, {
        value: tabValue,
        onChange: handleTabChange,
        "aria-label": "settings tabs"
    }, visibleTabs.map(function (tab) {
        return /*#__PURE__*/ React.createElement(Tab, {
            key: tab.label,
            label: tab.label,
            sx: {
                textTransform: 'none'
            }
        });
    }))), visibleTabs.map(function (tab, index) {
        return /*#__PURE__*/ React.createElement(CustomTabPanel, {
            key: tab.label,
            value: tabValue,
            index: index
        }, tab.component);
    }))));
};
export default Settings;
